import React from 'react';
import { SingleDomainPicker, selectedDomain, singleDomainSelection } from '@prerender/design-system/SingleDomainPicker';

import { useDomainSearch } from '../api/useDomainSearch';

export type DomainFilterProps = {
  domain?: string | null;
  onDomainChange: (domain?: string) => void;
};

export function DomainFilter({ domain, onDomainChange }: DomainFilterProps) {
  const { search, ...results } = useDomainSearch();

  return (
    <SingleDomainPicker
      results={results}
      onSearch={search}
      style={{ flexShrink: 0 }}
      value={singleDomainSelection(domain)}
      onChange={(selection) => onDomainChange(selectedDomain(selection))}
    />
  );
}
